export const sanitizeSlug = (slug: string, shouldReplaceHome = true) => {
  const sanitizedSlug = `/${slug.replace(/^\/|\/$/g, '')}/`;

  if (shouldReplaceHome && sanitizedSlug === '/home/') {
    return '/';
  }

  return sanitizedSlug;
};
